export const DayFilterEnum = {
  START: {active: true, display: 'Startbesök'},
  CONTINUED_START: {active: true, display: 'Forts. startbesök'},
  CT: {active: true, display: 'CT-besök'},
  PREVENTION: {active: true, display: 'Preventionsbesök'},
  PREVENTION_FOLLOW_UP: {active: true, display: 'Uppföljningssamtal'},
  FREE_BOOK: {active: true, display: 'Extrabesök'}
}
